import styled from 'styled-components';

export default styled.div`
  img {
    width: 75px;
    height: 75px;
    margin-bottom: 20px;
    margin-left: -10px;
  }

  h3 {
    margin-top: 0;
    font-size: 18px;
    line-height: 24px;
  }

  ul {
    max-height: 250px;
    padding: 0;
    list-style: none;
    overflow-y: auto;

    li {
      button {
        padding: 0;
        text-align: left;

        span,
        svg {
          vertical-align: middle;
        }

        svg {
          background-color: transparent;
          fill: #ffffff;
          border-radius: 2px;
          height: 16px;
          width: 16px;
          border: 1px solid ${({ theme: { colors } }) => colors.deepLightGrey};
          padding: 1px;
        }

        span {
          font-weight: 500;
          margin-left: 10px;
        }

        &.is-active {
          svg {
            background-color: ${({ theme: { colors } }) => colors.blue};
            border-color: ${({ theme: { colors } }) => colors.blue};
          }
        }
      }
    }
  }

  button {
    padding: 5px 40px;
    font-size: 14px;
    line-height: 36px;

    &.text-only {
      color: ${({ theme: { colors } }) => colors.blue};
    }
  }
`;
